





































import { Component, Vue } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import AddButton from '@/components/Admin/Layout/AddButton.vue';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import UnitGroupingItem from '@/ts/UnitGroupingItem';
import { dateTimeFormat } from '@/ts/DefaultTableConfigs';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';

@Component({
    components: {
        AddButton,
        FlexibleTable,
    },
})
export default class UnitGroupingList extends Vue {
    public tableEntity: string = 'UnitGroupingList';

    constructor() {
        super();
    }

    get columns(): any {
        return [
            { name: 'id', label: this.$t('general.id', 'ID'), align: 'left', field: 'id', sortable: true, required: true },
            { name: 'name', label: this.$t('general.name', 'Name'), align: 'left', field: 'name', sortable: true },
            { name: 'type', label: this.$t('general.type', 'Type'), align: 'left', field: 'type', sortable: true },
            { name: 'lastUpdated', label: this.$t('general.last-updated', 'Last updated'), align: 'left', field: 'updatedAt', sortable: true, filterType: 'date', dateFormat: dateTimeFormat,
                sort: (a: any, b: any) => {
                    const aTimestamp = a !== '' ? this.$moment(a, dateTimeFormat).valueOf() : 0;
                    const bTimestamp = b !== '' ? this.$moment(b, dateTimeFormat).valueOf() : 0;

                    return aTimestamp - bTimestamp;
                },
            },
            { name: 'size', label: this.$t('general.size-units', 'Size (units)'), align: 'left', field: 'size', sortable: true },
        ];
    }

    get defaultTableConfig(): TableViewConfig {
        return {
            visibleColumns: [
                'id',
                'name',
                'type',
                'lastUpdated',
                'size',
            ],
        };
    }

    get allGroupings(): UnitGroupingItem[] {
        return this.$store.getters['Groupings/getAllGroupings'];
    }

    public addGrouping() {
        this.$router.push({name: 'admin-grouping-add'});
    }

    public editGrouping(groupingId: number) {
        this.$router.push({ name: 'admin-grouping-edit', params: { groupingId: groupingId.toString() }});
    }

    public previewGrouping(groupingId: number) {
        this.$router.push({ name: 'admin-grouping', params: { groupingId: groupingId.toString() }});
    }

    public deleteGrouping(groupingId: number, groupingName: any): void {
        this.$store.commit(Mutations.SET_CONFIRM_POPUP_DATA, {
            confirmAction: 'Groupings/DELETE_GROUPING',
            confirmActionData: {groupingId, reload: false},
            confirmQuestionText: this.$t('confirmation.are-you-sure-you-want-to-delete-this-grouping', 'Are you sure you want to delete this grouping?'),
            confirmInfoText: groupingName,
            confirmButton: this.$t('forms.delete', 'Delete'),
            confirmIconVisibility: true,
            confirmIcon: 'fa-trash',
            confirmHeaderText: this.$t('general.delete-grouping', 'Delete grouping'),
            confirmButtonClass: 'hococo-close-form-btn',
        });
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_ALL_GROUPINGS);
    }
}
